module.exports = __webpack_public_path__ + "public/img/tiku_cbg2select.95a4fc49.png";